import React, { memo } from 'react';
import { PayStateT } from 'routes/HumanResourcesModule/PayState/helpers/types';
import { useTranslation } from 'react-i18next';

import { getColDefs } from 'routes/HumanResourcesModule/PayState/PayStateSynthesis/Vacant/helpers/colDefinitions';
import { getHasNoEndDate } from 'routes/HumanResourcesModule/PayState/PayStateSynthesis/Vacant/helpers/dataHelpers';
import HrDataGrid from 'routes/HumanResourcesModule/components/HrDataGrid/HrDataGrid';
import { getHrAutoGroupColDef } from 'routes/HumanResourcesModule/components/HrDataGrid/helpers/gridHelpers';
import { useGetVacantPositionsData } from '../helpers/hooks/payStateData';
import { TRACKABLE_EVENTS_METADATA } from 'helpers/trackerHelpers';

type Props = {
    payState: PayStateT;
};

const VacantGrid = ({ payState }: Props): React.ReactElement => {
    const { t } = useTranslation();

    const { data: vacantResponse, isLoading: isDataGridResponseLoading } =
        useGetVacantPositionsData(payState.id);
    const vacantPositions = vacantResponse?.data || [];

    const hasEndDate = getHasNoEndDate(vacantPositions);
    const columnDefs = getColDefs(hasEndDate);
    const customGridProps = {
        autoGroupColumnDef: {
            ...getHrAutoGroupColDef(),
            width: 350,
        },
    };

    const exportFileName = t('humanResources.payState.vacantExportFileName');

    return (
        <HrDataGrid
            title={t('humanResources.vacant')}
            trackEventMetadata={{
                gridName:
                    TRACKABLE_EVENTS_METADATA.human_resources.fullScreen
                        .vacantJobGrid,
            }}
            infoTooltip={t('humanResources.payState.vacantPositionDescription')}
            rowData={vacantPositions}
            columnDefs={columnDefs}
            exportFileName={exportFileName}
            gridProps={customGridProps}
            showTotal={false}
            isLoading={isDataGridResponseLoading}
        />
    );
};

export default memo(VacantGrid);
